var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvanceFilterActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#44B672",
    fillRule: "nonzero",
    stroke: "#ed8808",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.642 21.359a2.629 2.629 0 0 0 1.617-1.618H23v-1.763H12.26a2.629 2.629 0 0 0-4.966 0H3.606v1.763h3.688a2.629 2.629 0 0 0 3.348 1.618zm-1.747-2.5a.882.882 0 1 1 1.763 0 .882.882 0 0 1-1.763 0zM10.642 7.254a2.629 2.629 0 0 0 1.617-1.618H23V3.873H12.26a2.629 2.629 0 0 0-4.966 0H3.606v1.763h3.688a2.629 2.629 0 0 0 3.348 1.618zm-1.747-2.5a.882.882 0 1 1 1.763 0 .882.882 0 0 1-1.763 0zM15.93 14.306a2.629 2.629 0 0 0 1.619-1.617H23v-1.763h-5.451a2.629 2.629 0 0 0-4.965 0H3.606v1.763h8.978a2.629 2.629 0 0 0 3.347 1.617zm-1.745-2.499a.882.882 0 1 1 1.763 0 .882.882 0 0 1-1.763 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceFilterActive);
export default __webpack_public_path__ + "static/media/advance-filter-active.241e4a76a7ea64ecb9aee04268aa5634.svg";
export { ForwardRef as ReactComponent };